/*Javascript Document*/
$(document).ready(function () {
    $('.compare-data-tables thead').click(function () {
        $(this).siblings('tbody').slideToggle();
        $(this).closest('.compare-box').toggleClass('arrow');
    });
    $('.compare-box h3').click(function () {
        $(this).siblings('.compare-box-outer').slideToggle();
        $(this).toggleClass('arrow');
    });
  
  	 $('#comparison-select input').click(function () {
        var checkedBoxlength = $('#comparison-select input:checked').length;
        if (checkedBoxlength > 2) {
            $('.compare-error').show();
            return false;
        } else {
            $('.compare-error').css('display', 'none');
        }
        if (checkedBoxlength > 1) {
            $('#compare-btn').addClass('active');
        } else {
            $('#compare-btn').removeClass('active');
            $('.compare-desktop').hide();
        }
        display_comparison();
    });
  	var mobilehead = $('.header__main-mobile').outerHeight();
  $(document).on('click', 'a.active', function () {
        $('.compare-desktop').show();
        var anchorId = $(this).attr('href').split('#');
        var targetId = '#' + anchorId[1];
        $('html, body').animate({
            scrollTop: $(targetId).offset().top -mobilehead
        }, 500);
    });
 

});
$(window).ready(function(){

  window.onscroll = function () {
	onScrollSticky();
     $('.compare-cabinet-products.clearfix.issticky').slideDown().css({
		 	top:0,position:'fixed'
		 })
		 .animate({top:0}, 1000, function(){
			 
		  });
    
};
   
  
});


function display_comparison() {
        // get checkbox statuses
        var checkboxes = ['bold3', 'performance2', 'pro3', 'performanceplus2'];
        var check_statuses = {};
        var check_count = 0;
        for (var i = 0; i < checkboxes.length; i++) {
            check_statuses[ checkboxes[i] ] = $("#" + checkboxes[i]).is(':checked');
            if (check_statuses[ checkboxes[i] ]) {
                //console.log([ checkboxes[i] ]);
                check_count++;
                // add css to show true elements
                $('div.' + checkboxes[i]).show();
            } else {
                $('div.' + checkboxes[i]).hide();
            }
        }
    }
  

function onScrollSticky() 
{
	var headerheight = $('.header__top').outerHeight();
	var breadcrumbs = $('.header__main').outerHeight();
	var headingBox = $('.header__bottom').outerHeight();
	var breadcrumbs2 = $('.breadcrumbs').outerHeight();
	var headingBox2 = $('.headingBox').outerHeight();
	var cabh2 = $('.compare-cabinet-products h2').outerHeight();
	var cabhp = $('.compare-cabinet-products p').outerHeight();
	var headersticky = $('.rel.header__main').outerHeight();
	var totalheightbox = headerheight + breadcrumbs + headingBox + breadcrumbs2 + headingBox2 + cabh2 + cabhp + headersticky;
//alert(totalheightbox);
    if (document.getElementById("masthead") != null) {
        if (document.body.scrollTop > 0) {
            document.getElementById("masthead").classList.add("sticky");
          	
        } else if (document.documentElement.scrollTop > 0) {
            document.getElementById("masthead").classList.add("sticky");
        } else {
            document.getElementById("masthead").classList.remove("sticky");
        }
    }
    if ($(window).width() >= 769) {
     // alert(totalheightbox);
    
       
    }
    
  
}

